<template>
  <div class="sale-container" v-if="button.title">
    <div class="main-block">
      <router-link class="sale-link" :to="`/page/${button.link}`">
        <span>{{ button.title }}</span></router-link
      >
    </div>
  </div>
</template>
<script>
export default {
  name: 'SalesButton',
  props: {
    model: Object
  },
  data: () => ({
    button: {
      title: null,
      link: null
    }
  }),
  async created() {
    if (this.link == null) {
      await this.$store.dispatch('loadSaleButtonSettings')
    }

    const data = this.$store.getters.clientSettings.saleButtonsSettings
    this.button.link = data.fullLink
    this.button.title = data.buttonTitle
  }
}
</script>
<style lang="scss" scoped>
.main-block {
  display: flex;
  justify-content: center;
  margin-top: 3rem;
  margin-bottom: 3rem;
}

.sale-link {
  width: 300px;
  height: 60px;
  border: 1px solid #3a3a3a;
  display: flex;
  text-decoration: none;
  color: black !important;
  span {
    font-size: 1.8rem;
    margin: auto;
  }
  &:hover {
    background-color: #f4f4f4;
  }
}
</style>
